import { motion } from 'framer-motion'
import { Box } from '@mui/material'

import { useId } from 'react'

const MotionBox = motion.create(Box)

const gradientSolids = {
  blue: ['#2370ED', '#143F87'],
  purple: ['#7B83EB', '#131F8F'],
  red: ['#FF2F32', '#F76A1E'],
  yellow: ['#FEAD16', '#FF962D'],
  green: ['#91B659', '#406805'],
  blueInactive: ['#D7DDFF', '#D7DDFF'],
  redInactive: ['#FFDDD7', '#FFDDD7'],
  yellowInactive: ['#FFF3D7', '#FFF3D7'],
  greenInactive: ['#E5EED3', '#E5EED3'],
}

const gradients = {
  blue: 'linear-gradient(135deg, #2370ED, #143F87)',
  purple: 'linear-gradient(135deg, #7B83EB, #131F8F)',
  red: 'linear-gradient(135deg, #FF2F32, #F76A1E)',
  yellow: 'linear-gradient(135deg, #FEAD16, #FF962D)',
  green: 'linear-gradient(135deg, #91B659, #406805)',
  gray: 'linear-gradient(135deg, #e5e5e5 #e5e5e5)',
  blueInactive: 'linear-gradient(135deg, #E4F0FF, #E4F0FF)',
  redInactive: 'linear-gradient(135deg, #FFDDD7, #FFDDD7)',
  yellowInactive: 'linear-gradient(135deg, #FFF3D7, #FFF3D7)',
  greenInactive: 'linear-gradient(135deg, #E5EED3, #E5EED3)',
  grayInactive: 'linear-gradient(135deg, #f1f1f1, #f1f1f1)',
}

const fills = {
  blue: '#f1f1f1',
  purple: '#f1f1f1',
  red: '#f1f1f1',
  yellow: '#f1f1f1',
  green: '#f1f1f1',
  gray: '#a3a7aa',
  blueInactive: '#2370ED',
  redInactive: '#FF2F32',
  yellowInactive: '#FEAD16',
  greenInactive: '#91B659',
  grayInactive: '#a3a7aa',
}

function Arrow({
  color = 'blue',
  direction = 'right',
  isOpen = false,
  hovered = false,
}) {
  const gradientId = useId()

  const [start, end] = gradientSolids[color] || ['#F1F1F1', '#F1F1F1']

  switch (direction) {
    case 'down':
      return (
        <MotionBox
          animate={{
            scale: isOpen ? 1.1 : hovered ? 1.1 : 1,
            rotate: isOpen ? 180 : 0,
          }}
          transition={{
            duration: 0.25,
            type: 'spring',
            stiffness: 300,
            damping: 21,
          }}
          sx={{
            width: '25px',
            height: '25px',
            borderRadius: '50%',
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: 'none', // prevent hover issues
          }}
        >
          {/* Layered gradient backgrounds */}
          {Object.entries(gradients).map(([key, gradient]) => (
            <motion.div
              key={key}
              initial={false}
              animate={{ opacity: color === key ? 1 : 0 }}
              transition={{ duration: 0.3, ease: 'easeInOut' }}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: gradient,
                zIndex: 0,
              }}
            />
          ))}

          {/* Arrow icon */}
          <motion.svg
            width="13"
            height="8"
            viewBox="0 0 13 8"
            fill={fills[color]}
            xmlns="http://www.w3.org/2000/svg"
            style={{ zIndex: 1 }}
          >
            <path d="M1.92 0.329101L6.5 4.9091L11.09 0.329102L12.5 1.7391L6.5 7.7391L0.5 1.7391L1.92 0.329101Z" />
          </motion.svg>
        </MotionBox>
      )

    default:
      return (
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient
              id={gradientId}
              x1="0.987336"
              y1="-2.62821"
              x2="17.6119"
              y2="-1.70403"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor={start} />
              <stop offset="1" stopColor={end} />
            </linearGradient>
          </defs>
          <path
            d="M0.5 13.487L9.31795 4.66909H2.28319V0.75H16V14.4668H12.0809V7.43205L3.26296 16.25L0.5 13.487Z"
            fill={`url(#${gradientId})`}
          />
        </svg>
      )
  }
}

export default Arrow
